import { ListItem } from "../../../../core/services/BaseService";
import { DocumentsModel } from "../../../../core/components/UploadUtility";
import { StepStatus } from "./SidebarFormNavigation";


export enum Steps {
    GettingStarted = 'getting-started',
    RetirementDate = 'retirement-date',
    SelectDate = 'select-date',
    YourInformation = 'your-information',//Root
    PersonalInformation = 'personal-information',
    AddressInformation = 'address-information',
    ContactInformation = 'contact-information',
    PersonalStatus = 'personal-status',
    OptionSelection = 'option-selection',//Root
    OptionSelectionSelectYourOption = 'select-your-option',
    OptionSelectionMemberDeclaration = 'member-declaration',
    BeneficiaryDesignation = 'beneficiary-designation',//Root
    UnderstandingBeneficiaries = 'understanding-beneficiaries',
    BeneficiaryBenefit = 'beneficiary-benefit',
    BeneficiaryBurialAllowance = 'beneficiary-burial-allowance',
    TaxWithholding = 'tax-withholding',//Root
    FederalTaxWithholding = 'federal-tax-withholding',
    StateTaxWithholding = 'state-tax-withholding',
    DeclarationTaxWithholding = 'declaration-tax-withholding',
    DirectDeposit = 'direct-deposit',//Root
    DirectDepositAuthorization = 'direct-deposit-authorization',
    DirectDepositMemberDeclaration = 'direct-deposit-member-declaration',
    TemporaryAnnuity = 'temporary-annuity',
    ServiceRetirementSignOff = 'service-retirement-sign-off',
    ReviewApplication = 'review-application',
    UploadDocuments = 'upload-documents',
    SubmitApplication = 'submit-application',
}

export interface StepStatuses {
    gettingStarted?: string;
    selectDate?: string;
    yourInformation: string;
    personalInformation?: string;
    addressInformation?: string;
    contactInformation?: string;
    personalStatus?: string;
    optionSelection?: string;
    optionSelectionSelectYourOption?: string;
    optionSelectionMemberDeclaration?: string;
    beneficiaryDesignation?: string;
    understandingBeneficiaries?: string;
    beneficiaryBenefit?: string;
    beneficiaryBurialAllowance?: string;
    taxWithholding?: string;
    federalTaxWithholding?: string;
    stateTaxWithholding?: string;
    declarationTaxWithholding?: string;
    directDeposit?: string;
    directDepositAuthorization?: string;
    directDepositMemberDeclaration?: string;
    temporaryAnnuity?: string
    serviceRetirementSignOff?: string;
    reviewApplication?: string;
    uploadDocuments?: string;
    submitApplication?: string;
}

export interface StepInfoModel {
    slug: string,
    status: StepStatus;
    nextButtonLabel: string;
    cancelButtonLabel: string;
    hideNextButton: boolean,
    hideCancelButton: boolean
}
export interface SubmissionModel {
    submissionId?: number;
    submissionDate?: Date;
    retirementDate?: Date;
    lovSubmissionStatusId?: number
    submissionStatusDesc?: string;
    submissionType?: string;
    appSelfReviewed?: string;
}

export interface AppForRetirementModel {
    submissionId: number;
    submissionStatusId: number;
    personalInformation: PersonalInformationModel,
    optionSelection: OptionSelectionModel,
    temporaryAnnuity: TemporaryAnnuityModel,
    lovOptionSelections?: Array<LovOptionSelectionModel>,
    beneficiaryDesignation: BeneficiaryDesignationModel,
    taxWithHolding: TaxWithHoldingModel,
    directDeposit: DirectDepositModel;
    signOffModels: Array<ServiceRetirementSignOffModel>
    uploadedDocuments: Array<DocumentsModel>,
    phoneTypeListItems?: Array<ListItem>,
    personalStatusListItems?: Array<ListItem>,
    beneficiaryRelationListItems?: Array<ListItem>,
    withholdFederalIncomeTaxStatusListItems?: Array<ListItem>,
    withholdStateIncomeTaxStatusListItems?: Array<ListItem>,
    typeOfDepositListItems?: Array<ListItem>,
    documentList?: Array<ListItem>
}

export interface RetirementDateModel {
    submissionId: number;
    retirementDate?: Date;
    memberId?: string;
}

export interface CompareDateModel {
    fromDate?: string;
    toDate?: string;
}

export interface PersonalInformationModel {
    submissionId: number;
    memberId?: string;
    personalInfoVerified?: string
    firstName?: string;
    lastName?: string;
    middleName?: string;
    birthDate?: string & Date | null;
    ssn?: string;
    retirementEffDate?: string & Date | null;

    email?: string;
    confirmEmail?: string;
    phone?: string;
    phoneType?: string;
    alternatePhone?: string;
    alternatePhoneType?: string;
    lovPersonalStatusId?: number;
    personalStatusCd?: string;
    lovPersonalStatusDesc?: string;

    validateAddress?: boolean
    validateAddressType?: string;
    homeCountry?: string;
    homeAddress?: string;
    homeAddress2?: string;
    homeCity?: string;
    homeState?: string;
    homeZip?: string;

    mailingCountry?: string;
    mailingAddress?: string;
    mailingAddress2?: string;
    mailingCity?: string;
    mailingState?: string;
    mailingZip?: string;
    marriageDate?: string & Date | null;
    partnershipDate?: string & Date | null;
    appSelfReviewed?: string;
    fullName?: string;
    submitDeclaration?: boolean;
}

export interface LovOptionSelectionModel {
    id?: number;
    name?: string;
    description: string;
    confirmDescription: string;
    selected: boolean;
}

export interface OptionSelectionModel {
    submissionId?: number;
    afrApplicationId?: number;
    beneficiaryPaymentOptionId?: number;
    beneficiaryPaymentOptionDeclaration: boolean;
}

export interface TemporaryAnnuityModel {
    submissionId?: number;
    afrApplicationId?: number;
    tempAnnuitySelection?: string;
}

export interface BeneficiaryDesignationModel {
    submissionId?: number;
    afrMbrAffidavitId?: number;
    afrDecleration: string;
    beneDesigMinorChild?: string;
    beneficiaries?: Array<BeneficiaryModel>;
    burialBeneficiaries?: Array<BeneficiaryModel>;
}

export interface BeneficiaryModel {
    afrBeneId?: number;
    afrMbrAffidavitId?: number;
    beneFirstName?: string;
    beneMiddleName?: string;
    beneLastName?: string;
    beneOtherName?: string;
    beneSsn?: string;
    beneTin?: string;
    beneBirthDate?: string & Date | null;
    lovBeneRelationshipId?: number;
    percentage?: number;
    burialPercentage?: number;
    beneCountry?: string
    beneStreetAddress?: string;
    beneStreetAddress2?: string;
    beneCity?: string;
    beneState?: string;
    beneZip?: string;
    beneType?: string
}

export interface BeneficiaryBenefitStateModel {
    pageTitle?: string;
    pageOption?: string;
    NoEligibleBeneMessage?: string;
    relationships?: Array<ListItem>;
    isMarriedOrRegisteredPartnership?: boolean;
    manuallyProvidePercentage?: boolean;
    addNewTopButtonVisible: boolean;
    addNewSideButtonVisible: boolean;
    showDesignateMinorChildOptions: boolean;
    readOnlyRelationship: boolean;
    // hasNoEligibleBeneficiary: boolean
    addNewButtonText?: string;
    readMoreVisible: boolean;
    isAddingBeneficiary: boolean;
    isEditingBeneficiary: boolean;
    validationMessageTitle: string;
    validationMessage: string;
    completed?: boolean;
    selectedBeneficiary?: number;
    memberDeclarationVisible: boolean;
    memberDeclarationText?: string;
    memberDeclarationValue?: string;
}

export interface BeneficiaryBurialStateModel {
    selectedBeneficiary: number;
    wishOption?: string;
    relationships?: Array<ListItem>;
    summaryVisible?: boolean;
    isAddingBeneficiary: boolean;
    isEditingBeneficiary: boolean;
    addNewTopButtonVisible: boolean;
    addNewSideButtonVisible: boolean;
    validationMessageTitle: string;
    validationMessage: string;
    completed?: boolean;
}

export interface TaxWithHoldingModel {
    submissionId?: number;
    afrTaxWithholdId?: number;
    taxwithholdDecleration: boolean;
    federalTaxWithHolding?: FederalTaxWithHoldingModel;
    stateTaxWithHolding?: StateTaxWithHoldingModel;
}

export interface FederalTaxWithHoldingModel {
    submissionId?: number;
    afrTaxWithholdId?: number;
    federalTaxWithhold?: string;
    federalWithholdIncomeTaxStatus?: string;
    federalClaimsDependant?: number;
    federalDeductionsClaimed?: number;
    federalAdditionalWithold?: number;
    federalIncomeNotFromJob?: number;
}

export interface StateTaxWithHoldingModel {
    submissionId?: number;
    afrTaxWithholdId?: number;
    stateTaxWithhold?: string;
    stateWithholdIncomeTaxStatus?: string;
    stateMarriedWithholdIncomeAllowance?: number;
    stateSingleWithholdIncomeAllowance?: number;
    stateHeadOfHouseHoldIncomeAllowance?: number;
    stateAdditionalTaxToWithheldBasedOnTax?: number;
    stateAdditionalTaxToWithheldBasedOnBenefitPayment?: number;
}

export interface DirectDepositModel {
    submissionId?: number;
    afrDirectDepositId?: number;
    institutionName?: string;
    accountHolderName?: string;
    lovAccountTypeId?: number;
    bankRoutingNumeric?: string;
    bankAccountNumeric?: string;
    confirmbankAccountNumeric?: string;
    directDepositConsent: boolean
}

export interface AccruedSickLeaveModel {
    afrAccruedSickLeaveId?: number;
    submissionId?: number;
    sickLeaveCredit: boolean;
    sickLeaveCreditN: boolean;
    sickLeaveHours?: number;
}

export interface ServiceRetirementSignOffModel {
    submissionId?: number;
    afrServiceSignOffId?: number;
    active: boolean
    lovServiceSignOffId?: number;
    lovServiceSignOffCd?: string;
    lovServiceSignOffDesc?: string
}

export interface OraUrlModel {
    url?: string,
}
